import React from 'react';
import { Navigate } from 'react-router-dom';

export default function EsgReportHome() {
  return <Navigate to="dma" />;
}
